import React, { Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';

import Helper from '../common/Helper';
import i18n from '../../i18n';
import Screen from '../../utils/Screen';

const AddressPicker = React.lazy(() => import('../widget/AddressPicker'));

const HomeAddressCollection = (props) => {
    const [addressHome, setAddressHome] = useState('');
    const [gid, setGid] = useState();

    const { register, handleSubmit } = useForm();

    const onSubmit = () => {
        props.submitForm(addressHome);
    };

    useEffect(() => {
        props.updateData(addressHome || props.addressHome, gid);
    }, [addressHome, gid]);

    const handleSelect = (data) => {
        setAddressHome(data.label);
        setGid(data.gid);
    };

    return (
        <form id="form-step-3" onSubmit={handleSubmit(onSubmit)}>
            <label className="form-label">{i18n.t('home:home_address')}</label>
            <div className="helper-address">
                <p>{i18n.t('home:full_address')}</p>
                <Helper
                    classname="helper-home-collection why"
                    content={i18n.t('home:address_why')}
                    text={i18n.t('common:why')}
                    placement={Screen.isTabletOrUpper() ? 'right' : 'left'}
                />
            </div>
            <Suspense fallback={<div>{`${i18n.t('common:loading')}...`}</div>}>
                <AddressPicker
                    name="address"
                    ref={register({ required: true })}
                    scrollWaitFor={'map_displayed'}
                    placeholder={i18n.t('collection:default_address_placeholder')}
                    selectHandler={(data) => handleSelect(data)}
                    value={props.addressHome}
                    hasError={props.hasError}
                />
            </Suspense>
        </form>
    );
};

HomeAddressCollection.propTypes = {
    submitForm: PropTypes.func,
    updateData: PropTypes.func,
    addressHome: PropTypes.string,
    hasError: PropTypes.func
};

export default HomeAddressCollection;
